import React from "react";
import { get } from 'lodash';
import Header from 'marketing-components/dist/components/organisms/header';

 const PPHeader = (props) => {
    const pageData = JSON.parse(document.getElementById('data-pageData') && document.getElementById('data-pageData').innerHTML) || {};
    const ppauth = pageData.ppauth;
    const marketingHeader = JSON.parse(document.getElementById('mpp-header') && document.getElementById('mpp-header').innerHTML) || {};
    const content = get(marketingHeader, 'contentLoggedOut', '') || get(marketingHeader, 'content.contentLoggedOut', '');
    return (
        <>
            {props.ppccHeroPageHeader &&
                <>
                    {ppauth ?
                        <div id="merchant_header">
                            <div className="merchant-header"></div>
                        </div> :
                        <div id="mktg_header">
                            <Header content={content} config={marketingHeader.config} />
                        </div>

                    }
                </>
            }
        </>
    )
}

export default PPHeader;